import React from 'react';
import { Toast } from 'antd-mobile';
import { withCookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import { FolderOpenFilled } from '@ant-design/icons';
import { Spin } from 'antd';

import "./index.css";
import { _listFormGroup, _getDataFormCount, _listCommonForm, _saveCommonForm } from "../../server";

class MainPage extends React.Component {

    constructor(props) {
        super(props)
        const { cookies } = this.props;
        this.sid = cookies.get(process.env.TOKEN_KEY);
        this.state = { formGroups: [], draftFormCount: 0, commonFormList: [], showFormInfoView: false, currentForm: {}, isLoading: true };
        this.listFormGroup();
        this.getDataFormCount(1, [-2]);
        this.listCommonForm();
    }

    componentWillReceiveProps() {
        if (window.sessionStorage.getItem("index_tab") !== "mainTab") {
            return;
        }
        const { cookies } = this.props;
        this.sid = cookies.get(process.env.TOKEN_KEY);
        this.listFormGroup();
        this.getDataFormCount(1, [-2]);
    }

    async listFormGroup() {
        const res = await _listFormGroup(this.sid);
        if (res.code === 0) {
            this.setState({ formGroups: res.data.list, isLoading: false });
        }
    }

    async listCommonForm() {
        const res = await _listCommonForm(this.sid);
        if (res.code === 0) {
            this.setState({ commonFormList: res.data.list });
        }
    }

    async getDataFormCount(type, status) {
        const res = await _getDataFormCount(this.sid, type, status);
        if (res.code === 0) {
            if (status == -2) {
                //查询草稿数量
            }
            this.setState({ draftFormCount: res.data.count });
        }
    }

    async saveCommonForm(isCommon) {
        const res = await _saveCommonForm(this.sid, this.state.currentForm.definitionId, isCommon);
        if (res.code === 0) {
            this.state.currentForm.isCommon = isCommon;

            this.listCommonForm();

            if (isCommon === 1) {
                Toast.info('收藏为常用表单成功', 1);
            } else {
                Toast.info('取消常用表单成功', 1);
            }
        }
    }

    showFormInfo(e, item) {
        this.setState({ currentForm: item });
        this.setState({ showFormInfoView: true });
    }

    closeFormInfo = () => {
        this.setState({ showFormInfoView: false });
    }

    render() {
        var view_listFormGroup = this.state.formGroups.map((item, index) =>
            <div key={index} className="formAppContainer">
                <Link to={{ pathname: '/formlist', query: { group: item } }}>
                    <div className="formAppItem">
                        <i className="formAppIcon" style={{ "background": item.groupColor }}>
                            <FolderOpenFilled />
                        </i>
                        <p className="appDescTitle">{item.groupName}</p>
                        <p className="appData">共{item.formNum}张表单</p>
                    </div>
                </Link>
            </div>
        );

        if (this.state.isLoading) {
            view_listFormGroup = <Spin style={{ width: "100%", marginTop: "30%" }} size="large" />
        }

        return (<div className="mainPage">
            <div className="headerNav">
                <div className="headerBase">
                    <div className="headerBtn">
                        <Link to={{ pathname: '/formcommon' }}>
                            <span className="collectionRoute showIcon">
                                常用表单
				            </span>
                        </Link>
                        <Link to={{ pathname: '/draft' }}>
                            <span className="draftRoute">{this.state.draftFormCount} 草稿</span>
                        </Link>
                        <Link to={{ pathname: '/formlist' }}>
                            <span className="headerSerach"></span>
                        </Link>
                    </div>
                </div>
                <div className="headListWrap">
                    <div className="headerTab">
                        {
                            this.state.commonFormList.length === 0 ? <div className="innerTab">
                                <div className="collectionCard">
                                    <img style={{ "width": "93px", "height": "76px" }} src={require('../../common/images/home_empty_normal_bg.png')} />
                                    <div className="msg">
                                        <h3 className="collectionH">没有常用表单</h3>
                                        <p className="collectionDesc">将表单收藏为常用，可以在首页置顶</p>
                                    </div>
                                </div>
                            </div> : <div className="innerTab">
                                    {
                                        this.state.commonFormList.map((item, index) => {
                                            if (index < 4) {
                                                return <div className="collectionItem" onClick={(e) => this.showFormInfo(e, item)}>
                                                    <h3 className="itemTitle">{item.formName}</h3>
                                                    <div className="itemIcon bd_shenpidan"></div>
                                                </div>
                                            } else {
                                                return "";
                                            }
                                        })
                                    }
                                </div>
                        }
                    </div>
                </div>
            </div>
            <div className="formApp">
                <h2 className="formAppTitle">表单应用</h2>
                <div className="formAppList">{view_listFormGroup}</div>
            </div>
            <div className="showMoreList">
                <p>共{this.state.formGroups.length}个应用</p>
            </div>
            {
                this.state.showFormInfoView ?
                    <div className="formInfo">
                        <div className="maskLayer" style={{ "opacity": this.state.showFormInfoView ? "0.4" : "" }} onClick={this.closeFormInfo}>

                        </div>
                        <div className="information">
                            <div className="popDragIcon"></div>
                            <div className="basicInformation">
                                <div className="title">{this.state.currentForm.formName}</div>
                                <div className="group">{this.state.currentForm.groupName}</div>
                                <div className="basicInfoIcon">
                                    {
                                        this.state.currentForm.isCommon === 1 ? <i className="iconBasicInfo collected" onClick={() => {
                                            this.saveCommonForm(0);
                                        }}></i>
                                            : <i className="iconBasicInfo noCollected" onClick={() => {
                                                this.saveCommonForm(1);
                                            }}></i>
                                    }
                                    {
                                        // <i className="iconBasicInfo iconMoreDetail"></i>
                                    }
                                </div>
                            </div>
                            <div className="footer">
                                <Link to={{ pathname: '/formdatalist', query: { definitionId: this.state.currentForm.definitionId } }}>
                                    <div className="detailData arrow"><i className="icon"></i>明细数据</div>
                                </Link>
                                {
                                    // <div className="statistical arrow"><i className="icon"></i>统计报表</div>
                                }
                                <Link to={{ pathname: '/formmain', query: { formId: this.state.currentForm.formId } }}>
                                    <div className="addForm">发起</div>
                                </Link>
                            </div>
                        </div>
                    </div> : ""
            }
        </div>);
    }

}

export default withCookies(MainPage);